<template>
  <div class="summary-passenger-row">
    <vb-icon
      v-if="is_infant(passenger) && !seat"
      name="infant"
      color="AAA"
      :size="18"
    />
    <traveler-icon v-else :traveler="passenger" color="AAA" :size="18" />
    <span class="summary-passenger-row__name">
      {{ formatPassengerName(passenger) }}
    </span>
    <span class="summary-passenger-row__seat">
      <span v-if="seat" class="text-primary semibold">{{ seat.number }}</span>
      <span
        v-else-if="is_infant(passenger)"
        class="text-primary semibold text-nowrap"
      >Neonato in braccio</span>
      <span v-else class="text-gray semibold">Scelta della compagnia</span>
    </span>
  </div>
</template>

<script>
  import { formatPassengerName } from '@liveflight/utilities/mixins';
  import { is_infant } from '@liveflight/utilities';
  import TravelerIcon from '@liveflight/components/blocks/traveler/traveler-icon.vue';

  export default {
    name: 'summary-passenger-row',
    components: {
      'traveler-icon': TravelerIcon,
    },
    props: {
      passenger: Object,
      seat: Object,
    },
    data() {
      return {
        formatPassengerName,
      };
    },
    methods: {
      is_infant,
    },
  };
</script>

<style lang="scss">
  .summary-passenger-row {
    display: flex;
    align-items: center;
    gap: 10px;

    &:not(:last-child) {
      padding-bottom: 12px;
      border-bottom: $card-border-width solid $card-border-color;
    }

    &__name {
      flex-grow: 1;
      color: $body-color;
      font-weight: $font-weight-normal;
    }

    &__seat {
      margin-left: auto;
      text-align: end;
    }
  }
</style>
